import { TOGGLE_LEFT_SIDEBAR } from "../constants";

export function toggleLeftSidebar(value) {
  return { type: TOGGLE_LEFT_SIDEBAR };
}
